const BASE_URL = "erp-recruitment";

export const getRecruitmentRequirementUrl = (screenCode: string) => {
  return `${BASE_URL}/request/${screenCode}`;
};

export const deleteRecruitmentRequirementUrl = (
  screenCode: string,
  id: string
) => {
  return `${BASE_URL}/request/${screenCode}/${id}`;
};

export const approveRecruitmentRequirementUrl = (screenCode: string) => {
  return `${BASE_URL}/request/${screenCode}/approve/mng`;
};

export const rejectRecruitmentRequirementUrl = (screenCode: string) => {
  return `${BASE_URL}/request/${screenCode}/approve/mng`;
};
export const getRecruitmentRequirementDetailUrl = (
  screenCode: string,
  id: string
) => {
  return `${BASE_URL}/request/${screenCode}/${id}/detail`;
};

export const updateRecruitmentRequirementUrl = (
  screenCode: string,
  id: string
) => {
  return `${BASE_URL}/request/${screenCode}/${id}`;
};

export const getListManagersUrl = (id) => `${BASE_URL}/request/${id}/cbql`;

export const getDataBoundaryUrl = ({ departmentCode, year }) =>
  `${BASE_URL}/boundary/${year}/${departmentCode}`;

export const postFileUrl = `${BASE_URL}/file/upload`;

export const getDepartmentInfoUrl = `${BASE_URL}/request/department/info`;

export const getRecruitmentPositionUrl = `${BASE_URL}/position/option`;
export const getDepartmentPositionDetailUrl = (screenCode) =>
  `${BASE_URL}/position/${screenCode}/detail`;
